

















import { Component, Ref, Vue, Emit, Model, Prop, Watch, Provide } from 'vue-property-decorator';
import { addBrand, getEditBrand } from '@/utils/api'; //提交抽屉的数据
import Upload from '../brand/upload.vue';
import { RulesForm, RuleFormAdd } from '../interface';
@Component({
  components: { Upload },
})
export default class AddBrand extends Vue {
  loading: boolean = false; //加载
  @Prop(Object) PropsData!: object;
  @Prop(String) Title!: string;
  @Watch('PropsData', { immediate: true, deep: true })
  onChildChanged(newVal, oldVal) {
    this.$nextTick(() => {
      this.ruleForm.brandName = newVal.brandName;
      this.ruleForm.imageUrl = newVal.imageUrl;
      this.ruleForm.brandId = newVal.brandId;
      this.ruleForm.id = newVal.id;
      this.ruleForm.brandState = newVal.brandState;
    });
    this.ruleForm = {
      brandName: '', //品牌名称
      imageUrl: '', //图片路径
      brandId: '', //品牌id
      id: 0, //id
      brandState: 0,
    };
  }
  //添加品牌抽屉默认关闭
  drawer: boolean = false;
  //表单
  formLabelWidth: string = '80px';
  //表单配置
  ruleForm: RuleFormAdd = {
    brandName: '', //品牌名称
    imageUrl: '', //图片路径
    brandId: '', //品牌id
    id: 0, //id
    brandState: 0,
  };
  rules: RulesForm = {
    brandName: [
      { required: true, message: '请输入品牌名称', trigger: 'blur' },
      { min: 2, max: 15, message: '长度在 2 到 15 个字符', trigger: 'blur' },
    ],
    imageUrl: [{ required: true, message: '请上传品牌logo', trigger: 'blur' }],
  };

  created() {
    if (this.PropsData['brandName'] != '') {
      this.ruleForm = {
        brandName: this.PropsData['brandName'], //品牌名称
        imageUrl: this.PropsData['imageUrl'], //图片路径
        brandId: this.PropsData['brandId'], //品牌id
        id: this.PropsData['id'], //id
        brandState: this.PropsData['brandState'],
      };
    }
  }
  // 传参
  handleAvatarSuccess(img) {
    this.ruleForm.imageUrl = img;
  }
  //抽屉的提交方法
  submitDrawer(v) {
    (this.$refs[v] as any).validate((valid) => {
      if (valid) {
        this.loading = true;
        if (this.Title == '编辑品牌') {
          getEditBrand({
            brandName: this.ruleForm.brandName,
            imageUrl: this.ruleForm.imageUrl,
            brandId: this.ruleForm.brandId,
            id: this.ruleForm.id,
            brandState: this.ruleForm.brandState,
          })
            .then((data) => {
              this.$message({
                message: '提交成功',
                type: 'success',
              });
              this.$emit('isDialog', false); //关闭抽屉
              this.$emit('flush');
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          addBrand({
            brandName: this.ruleForm.brandName,
            imageUrl: this.ruleForm.imageUrl,
          })
            .then((data) => {
              this.$message({
                message: '提交成功',
                type: 'success',
              });
              this.$emit('isDialog', false); //关闭抽屉
              this.$emit('flush');
              this.$nextTick(function () {
                (this.$refs.ruleForms as any).resetFields();
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      } else {
        return false;
      }
    });
  }

  //添加品牌提示框的方法
  handleClose(done) {
    this.$confirm('确认关闭？')
      .then((_) => {
        done();
      })
      .catch((_) => {});
  }
  // 抽屉的取消方法
  cancelForm() {
    if (this.Title == '添加品牌') {
      this.ruleForm = { brandName: '', imageUrl: '', brandId: '', id: 0, brandState: 0 };
      this.$message({
        message: '已取消添加品牌',
        type: 'info',
      });
      this.$emit('isDialog', false); //关闭抽屉
    } else if (this.Title == '编辑品牌') {
      this.$message({
        message: '已取消编辑品牌',
        type: 'info',
      });
      this.$emit('isDialog', false); //关闭抽屉
    }
  }
}
